export const NotificationUserTypes = {
    NA: 0,
    CANDIDATE: 1,
    EMPLOYER: 2,
    CANDIDATE_AND_EMPLOYER: 3,
};

export type NotificationUserTypesKeys = keyof typeof NotificationUserTypes;
export type NotificationUserTypesValues = typeof NotificationUserTypes[NotificationUserTypesKeys]

export const allNotificationTypes: NotificationUserTypesValues[] = Object.values(NotificationUserTypes);
